import React, { useState, Fragment } from "react";
import styled from "styled-components";
import PriceBox from "./PriceBox";

// import { FontContainer } from "../Routers/Home/style.js";

const FontDetaiSubTitle = styled.p`
  font-size: 40px;
  font-family: HYGothicL;
  color: #000000;
  display: flex;
  justify-content: center;
  padding-top: 60px;
`;

const UnderLine = styled.p`
  background-color: rgba(232, 232, 232, 1);
  height: 1px;
  width: 900px;
  margin-top: 30px;
  margin-bottom: 30px;
`;
const FontInfoDetail = styled.div`
  margin-top: 50px;
  width: 900px;
  font-size: 13px;
  color: #363434;
  display: grid;
  grid-auto-rows: minmax(min-content, 30px);
  grid-template-columns: 75px 30px 1fr;
`;

const TitleColumns = styled.p`
    display:flex;
    align-items:start
    width:75px;
    justify-self:end;
    /*font-family:hy1148100115;*/
    color:#363434;
    font-size:13px;
    align-items: start;
  
`;

const SpecColumns = styled.p`
  width: 100%;
  /*font-family:hy1148100115;*/
  color: #363434;
  font-size: 13px;
  & > span {
    display: block;
    vertical-align: top;
    // margin-bottom:30px;
    line-height: 3;
  }
`;

const ProductTitle = styled.div`
  font-size: 25px;
  padding: 5px 15px 30px 15px;
`;

export default ({ detail, info }) => {
  const FontType = {
    TTF: "TTF",
    OTF: "OTF",
    OTFPro: "OTF Pro",
  };
  const [tabSelect, setTabSelect] = useState(FontType.TTF);
  const isSystemFont = (name) => {
    const systemFont = [
      "바탕",
      "바탕체",
      "굴림",
      "굴림체",
      "궁서",
      "궁서체",
      "돋움",
      "돋움체",
    ];
    return systemFont.some((type) => type.includes(name));
  };

  const isBundle = (name) => {
    const systemFont = ["새굴림", "새바탕"];
    return systemFont.some((type) => type.includes(name));
  };

  const priceData = {
    home: {
      selected: "smart",
      target: "상업",
      color: "#e81f61",
      options: {
        webtoon: {
          webtoon1: {
            title: "WEBTOON",
            price: "110000",
            monthPrice: "10000",
            count: "1",
            desc: "웹툰전용 폰트제공 \n 웹툰제작 및 웹툰홍보",
          },
        },
        cad: {
          cad1: {
            title: "CAD",
            price: "88000",
            monthPrice: "8000",
            count: "1",
            desc: "CAD 전용 폰트제공 \n 도면 및 문서 작성",
          },
        },
        solo: {
          solo1: {
            title: "SOLO",
            price: "99000",
            monthPrice: "9000",
            count: "1",
            desc: "개인사용 \n 모든 라이선스 제공",
          },
          soloEdu: {
            title: "SOLO 학생용",
            price: "0",
            monthPrice: "0",
            count: "1",
            desc: "초·중·고 대학생용\n 모든 라이선스 제공 (무료)",
          },
        },
        smart: {
          smart1: {
            title: "Smart one",
            price: "440000",
            monthPrice: "40000",
            count: "1",
            desc: "100인 미만 기업/기관 \n 모든 라이선스 제공",
          },
          smart25: {
            title: "Smart 25",
            price: "990000",
            monthPrice: "90000",
            count: "25",
            desc: "100인 미만 기업/기관 \n 모든 라이선스 제공",
          },
          smart50: {
            title: "Smart 50",
            price: "1430000",
            monthPrice: "120000",
            count: "50",
            desc: "100인 미만 기업/기관 \n 모든 라이선스 제공",
          },
          smartPlus: {
            title: "Smart Plus",
            price: "상담전용상품",
            monthPrice: "8000",
            count: "0",
            desc: "100인 이상 대기업/기관 \n 폰트 컨설팅 지원",
          },
        },
      },
    },
  };

  const { home } = priceData;

  const smart = home.options["smart"];
  const solo = home.options["solo"];


  return (
    <>
      <FontDetaiSubTitle>폰트 정보</FontDetaiSubTitle>
      <UnderLine />

      <FontInfoDetail>
        <TitleColumns>폰트명</TitleColumns>
        <span />
        <SpecColumns>
          {detail?.familyname} / {detail?.familyname_eng}
          <span className="fontname">
            {info?.length}종{" "}
            {info?.map((f, index) => {
              return f.kor + " , ";
            })}
          </span>
        </SpecColumns>

        <TitleColumns>파일명</TitleColumns>
        <span />
        <SpecColumns>
          {info?.map((f, index) => {
            return f.filename + " , ";
          })}
        </SpecColumns>

        {/* {detail?.concept ? <TitleColumns>컨셉</TitleColumns> : ""}

        {detail?.concept ? (
          <>
            <span />
            <SpecColumns>{detail?.concept} </SpecColumns>
          </>
        ) : (
          ""
        )} */}

        <TitleColumns>유형</TitleColumns>
        <span />
        <SpecColumns> 고딕 </SpecColumns>

        <TitleColumns>버전</TitleColumns>
        <span />
        <SpecColumns>묵향 6.2 Windows / Mac 용 </SpecColumns>
        <TitleColumns>스펙</TitleColumns>
        <span />
        <SpecColumns>
          영문 95자 / 한글 {info && info[0].korean_char_num.toLocaleString()}자
          / {info && info[0]?.slang == "1" ? "외계어 215자 /" : ""}{" "}
          {isSystemFont(detail?.familyname)
            ? "한자 7,500자 / KS+WGL4(라틴 가변)"
            : `${
                isBundle(detail?.familyname)
                  ? `한자 27,000자 / KS+WGL4(라틴 가변)`
                  : `한자 지원 ${
                      info && info[0].hanja === 1 ? "" : "하지 않음"
                    }`
              }`}{" "}
          {/* {tabSelect === "PRO" ? " / 고정폭 가변 지원" : ""} */}
        </SpecColumns>

        <TitleColumns>포맷</TitleColumns>
        <span />
        <SpecColumns> TTF / OTF </SpecColumns>

        <TitleColumns>공급사</TitleColumns>
        <span />
        <SpecColumns>
          {detail?.familyname_eng == "eundanMedium"
            ? "(C) Copyright 2022 Koreaeundan Corporation. All rights reserved. Font designed by HanYang Inc. "
            : "(주)한양정보통신 | http://hanyang.co.kr"}
        </SpecColumns>
      </FontInfoDetail>

      <FontDetaiSubTitle>폰트 구매</FontDetaiSubTitle>
      <UnderLine />

      <ProductTitle>기업/상업용</ProductTitle>
      <PriceBox home={home} choice={smart} color="#E81F61" />

      <ProductTitle>개인/비상업용</ProductTitle>
      <PriceBox home={home} choice={solo} color="#E81F61" />

      <FontDetaiSubTitle>연관 폰트</FontDetaiSubTitle>
      <UnderLine />

      {/* 
      <FontContainer ref={containerRef}>
        {data?.map((f, index) => {
          // if ((index+1)%28 === 0){
          //     doc.addPage();
          // }

          const text = (
            <FontBox
              key={f.idx}
              id={f.idx}
              type={f.types}
              webfont={f.webfontname}
              familyname={f.familyname}
              isNew={f.is_new}
              font={f}
              family_type={f.family_type}
            />
          );
          return text;
        })}
      </FontContainer> */}
    </>
  );
};
